import * as loadingAction from "../../../../store/loading/action";
import * as messageAction from "../../../../store/message/action";

import { Col, Modal } from "reactstrap";
import {
  GET_DT_OFFSHPRE,
  GET_DT_OFFSHPRE_COLUMN,
  SAVE_DT_OFFSHPRE,
  SAVE_DT_OFFSHPRE_COLUMN,
} from "helpers/url_api_constant";
import React, { useEffect, useState } from "react";
import Select, { OptionProps, components } from "react-select";
import SelectColor, { colorOption } from "components/Custom/SelectColor";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";

import $ from "jquery";
import BootstrapTable from "react-bootstrap-table-next";
import Flatpickr from "react-flatpickr";
import OverButton from "../../../../components/Custom/Overbutton";
import PropTypes from "prop-types";
import { getPermission } from "../../../../helpers/auth_helper";
import moment from "moment";
import { post } from "helpers/api_helper";
import { useDispatch } from "react-redux";

function numberFormat(number, digit = 2) {
  if (number === null || number === "null" || number === "") return "";
  function isFloat(n) {
    return Number(n) === n && n % 1 !== 0;
  }
  if (isFloat(number))
    return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
      minimumFractionDigits: digit,
    });
  return parseFloat(number).toLocaleString(undefined, {
    minimumFractionDigits: digit,
  });
}

function Offshore(props) {

  const dispatch = useDispatch();
  const permission = getPermission();
  //   const [dateSelected, setDateSelected] = useState(props.dateSelected);
  const [AVGObject, setAVGObject] =useState({mode:"AVG",show_name:""});
  const [dateNow, setDateNow] = useState(moment(new Date()).format("YYYY-MM"));
  const [showManageColumn, setShowManageColumn] = useState(false);
  const [columnDataList, setColumnDataList] = useState([]);
  const [columnManageList, setColumnManageList] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [modelDeviceList, setModelDeviceList] = useState([]);
  const [modelDeviceListToSave, setModelDeviceListToSave] = useState([]);

  const [dataModel, setDataModel] = useState({
    PID: "",
    OFFSHORE_DATE: "",
    OFFSHORECOLUMN_PID: "",
    OFFSHORECOLUMN_ORDER: 0,
    OFFSHORECOLUMN_NAME: "",
    OFFSHORE_DAY: 0,
    OFFSHORE_DATA: 0,
    SOURCE_PID: null,
    SOURCE_NAME: null,
    PRIORITY_FLAG: 0,
    STATUS_FLAG: 0,
  });



  const [columnRenderList, setColumnRenderList] = useState([
    {
      dataField: "Dummy",
      text: "Date",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        backgroundColor: "#7E8EDA",
        width: "2%",
      },
      formatter: CountIndexRow,
    },
  ]);

  const rowStyle = (row, rowIndex) => {
    const style = {};
    if (
      rowIndex == modelDeviceList.length - 1 &&
      dateNow == moment(props.dateSelected).format("YYYY-MM")
    ) {
      style.fontWeight = "bold";
      style.color = "#FFFFFF";
      style.border = "2px solid #FFFFFF";
      // style.opacity = "0.6";
    } else {
      style.color = "white";
    }

    return style;
  };
  
  const calculateAVG = () => {
    let planAvg =
      modelDeviceList.reduce(
        (a, b) => a + parseFloat(b.OFFSHORE_DATA),
        0
      ) / modelDeviceList.length;
    let avgObj = { mode:"AVG",date: "AVG", OFFSHORE_DATA: planAvg };
    columnDataList.map(collumn => {
      let sum = 0;
      modelDeviceList.map(object => {
        sum += object[collumn.OFFSHORECOLUMN_NAME];
      });
      avgObj[collumn.OFFSHORECOLUMN_NAME] = sum / modelDeviceList.length;
    });
    setAVGObject(avgObj);
  };

  useEffect(() => {
    calculateAVG();
  }, [modelDeviceList]);

  const rowStyleFontWhite = (row, rowIndex) => {
    const style = {};
    // style.fontWeight = 'bold';
    style.color = "white";

    return style;
  };

  const addHeaderTable = () => {
    let prevHeader = document.getElementById(
      "offshore-gas-volume-table-header"
    );
    prevHeader && prevHeader.remove();
    let thead = document
      .getElementById("offshore-tab-table")
      .getElementsByTagName("thead")[0];
    let tr = document.createElement("tr");
    tr.innerHTML =
      '<th id="offshore-gas-volume-table-header" colspan="' +
      (columnDataList.length + 2) +
      '" style="text-align:center;background-color:#556ee6;color:#FFFFFF">Offshore Gas Volume</th>';
    thead.prepend(tr);
  };
  const getColumn = () => post(GET_DT_OFFSHPRE_COLUMN, {});
  const handleAddColumn = () => {
    setColumnManageList(prevent => [
      ...prevent,
      {
        ROW: columnManageList.length + 1,
        PID: "",
        OFFSHORECOLUMN_ORDER: columnManageList.length + 1,
        OFFSHORECOLUMN_NAME: "",
        STATUS_FLAG: "",
        SCADATAG_NAME: "",
        QTYPOINT_NAME: "",
        OFFSHORECOLUMN_DESC: "",
        OFFSHORECOLUMN_TYPE: "",
        OFFSHORECOLUMN_SHOW: true,
        PRIORITY_FLAG: 0,
        STATUS_FLAG: 0,
        color: colorOption[0],
        show: { label: "Show", value: 1 },
        source: { label: "Manual", value: 0 },
      },
    ]);
  };

  const handleSaveColumn = async () => {
    function validateDuplicate() {
      let valueArr = columnManageList.map(function (item) {
        return item.OFFSHORECOLUMN_NAME;
      });
      let isDuplicate = valueArr.some(function (item, idx) {
        return valueArr.indexOf(item) != idx;
      });
      return isDuplicate;
    }
    if (validateDuplicate()) {
      dispatch(messageAction.showMessage("Column name is duplicate."));
      throw "exit";
    }
    dispatch(loadingAction.showLoading());
    try {
      if (
        !columnManageList.some(
          row => row.OFFSHORECOLUMN_NAME == "" || row.OFFSHORECOLUMN_ORDER == ""
        )
      ) {
        let data = [...columnManageList];
        let res = await post(SAVE_DT_OFFSHPRE_COLUMN, data);
        if (res.resultCode == 200) {
          fetchData();
          setShowManageColumn(false);
          dispatch(messageAction.showMessage("Save success."));
        }
      } else {
        dispatch(messageAction.showMessage("Plesae key in."));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  
  const generateRow = () => {
    function addDays(date, days) {
      var result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    }
    function getDaysInMonth(month, year) {
      var date = new Date(year, month, 1);
      var days = [];
      while (date.getMonth() === month) {
        days.push({
          date: new Date(date),
          OFFSHORE_DATE: moment(new Date(date)).format("YYYY-MM-DD"),
          OFFSHORE_DAY: new Date(date).getDate(),
        });
        date.setDate(date.getDate() + 1);
      }
      return days;
    }
    let currentDate = addDays(new Date(), -1);
    let startDate = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1
    );

    let dayList;
    let dateDiff = currentDate.getDate() - startDate.getDate() + 1;



    if (
      props.dateSelected &&
      (props.dateSelected.getFullYear() < currentDate.getFullYear() ||
        (props.dateSelected.getMonth() < currentDate.getMonth() &&
          props.dateSelected.getFullYear() == currentDate.getFullYear()))
    ) {
      dayList = getDaysInMonth(
        props.dateSelected.getMonth(),
        props.dateSelected.getFullYear()
      );

    } else {
      dayList = getDaysInMonth(
        currentDate.getMonth(),
        currentDate.getFullYear()
      );
      dayList = dayList.slice(0, dateDiff);
    }
    // console.log(dayList)
    dayList = addFieldToModelDeviceList(dayList);
    setModelDeviceList(dayList);
  };
  const ButtonAction = (cell, row, rowIndex, formatExtraData) => {
    return (
      <div>
        {/* <button
            type="button"
            className="btn btn-primary me-2"
            onClick={()=>{}}
          >
            Refresh
          </button> */}
        {permission.eGLP &&(
          <button
            type="button"
            className="btn btn-sm btn-success me-2"
            onClick={() => {
              // console.log(row);
              handleSaveDataByRow(row);
            }}
          >
            Save
          </button>
        )}
      </div>
    );
  };

  const formatNumber = (cellContent, row) => {
    return <div>{numberFormat(cellContent, 2)}</div>;
  };

  const renderColumn = () => {
    // console.log(columnDataList)
    setColumnRenderList([
      {
        dataField: "Dummy",
        text: "Date",
        headerAlign: "center",
        editable: false,
        align: "center",
        headerStyle: {
          backgroundColor: "#556ee6",
          width: "50px",
          fontSize: "12px",
        },
        style: { width: "50px" },
        formatter: CountIndexRow,
      },
      ...columnDataList
        .sort((a, b) =>
          a.OFFSHORECOLUMN_ORDER > b.OFFSHORECOLUMN_ORDER
            ? 1
            : b.OFFSHORECOLUMN_ORDER > a.OFFSHORECOLUMN_ORDER
              ? -1
              : 0
        )
        .filter(
          obj =>
            obj.OFFSHORECOLUMN_SHOW == true || obj.OFFSHORECOLUMN_SHOW == "true"
        )
        .map(obj => ({
          dataField: obj.OFFSHORECOLUMN_NAME.replaceAll(".", "_"),
          text: obj.OFFSHORECOLUMN_NAME,
          headerAlign: "center",
          editable: true,
          align: "center",
          editorStyle: () => {
            return { height: "25px" }
          },
          headerStyle: {
            backgroundColor: colorOption[obj.OFFSHORECOLUMN_TYPE].label,
            width: "90px",
            fontSize: "12px",
          },
          formatter: formatNumber,
          style: { width: "90px", cursor: "pointer" },
          classes: (cell, row, rowIndex, colIndex) => {
            let className = "";
            if (obj.STATUS_FLAG != 0) className += "from-source";
            if (obj.STATUS_FLAG == 1 || obj.STATUS_FLAG == 3)
              className += " pmis";
            return className;
          },
          validator: (newValue, row, column, done) => {
            setTimeout(() => {
              if (isNaN(newValue)) {
                return done({
                  valid: false,
                  message: "Should be numeric",
                });
              }
              return done();
            }, 0);
            return {
              async: true,
            };
          },
        })),
        
      {
        dataField: "df2",
        isDummyField: true,
        text: "Action",
        headerAlign: "center",
        editable: false,
        align: "center",
        headerStyle: {
          backgroundColor: "#556ee6",
          width: "100px",
          fontSize: "12px",
        },
        style: { width: "100px" },
        formatter: ButtonAction,
      },
    
    ]);
  };
  const handleShowManageColumn = async () => {
    setColumnManageList([]);
    dispatch(loadingAction.showLoading());
    try {
      setShowManageColumn(true);
      let column = await getColumn();
      setColumnManageList(
        column.data.dtOffshoreColumnList.map((obj, index) => ({
          ...obj,
          ROW: index + 1,
          color: colorOption[obj.OFFSHORECOLUMN_TYPE],
          show:
            obj.OFFSHORECOLUMN_SHOW == 1
              ? { label: "Show", value: 1 }
              : { label: "Hide", value: 0 },
        }))
      );
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }

    dispatch(loadingAction.hideLoading());
  };
  const saveAll = async datalist => {
    dispatch(loadingAction.showLoading());
    try {
      let data = [];
      datalist.map(obj => {
        columnDataList.map(objColumn => {
          data.push({
            ...obj[
            `${objColumn.OFFSHORECOLUMN_NAME.replaceAll(".", "_")}__data`
            ],
            OFFSHORE_DATA:
              obj[objColumn.OFFSHORECOLUMN_NAME.replaceAll(".", "_")],
          });
        });
      });
      let res = await post(SAVE_DT_OFFSHPRE, data);
      if (res.resultCode == 200) {
        // dispatch(messageAction.showMessage("Save success."));
        fetchData();
      } else {
        dispatch(messageAction.showMessage(res.resultDescription));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  const handleSaveData = async () => {
    dispatch(loadingAction.showLoading());
    try {
      let data = [];
      modelDeviceList.map(obj => {
        columnDataList.map(objColumn => {
          data.push({
            ...obj[
            `${objColumn.OFFSHORECOLUMN_NAME.replaceAll(".", "_")}__data`
            ],
            OFFSHORE_DATA:
              obj[objColumn.OFFSHORECOLUMN_NAME.replaceAll(".", "_")],
          });
        });
      });
      // let res = await post(SAVE_DT_OFFSHPRE, data);
      // if (res.resultCode == 200) {
      //   dispatch(messageAction.showMessage("Save success."));
      //   fetchData();
      // } else {
      //   dispatch(messageAction.showMessage(res.resultDescription));
      // }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  const handleSaveDataByRow = async row => {
    dispatch(loadingAction.showLoading());
    try {
      let data = [];

      columnDataList.map(objColumn => {
        // console.log(row)
        data.push({
          ...row[`${objColumn.OFFSHORECOLUMN_NAME.replaceAll(".", "_")}__data`],
          OFFSHORE_DATA:
            row[objColumn.OFFSHORECOLUMN_NAME.replaceAll(".", "_")],
        });
      });
      //  console.log(row)
      // console.log(row,data);
      let res = await post(SAVE_DT_OFFSHPRE, data);
      if (res.resultCode == 200) {
        dispatch(messageAction.showMessage("Save success."));
        // fetchData()
      } else {
        dispatch(messageAction.showMessage(res.resultDescription));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  const fetchData = async () => {

    dispatch(loadingAction.showLoading());
    try {
      // generateRow();
      let column = await getColumn();
      setColumnDataList(
        column.data.dtOffshoreColumnList.map((obj, index) => ({
          ...obj,
          ROW: index + 1,
        }))
      );
      let data = await post(GET_DT_OFFSHPRE, {
        OFFSHORE_MONTHYEAR: moment(props.dateSelected).format("YYYY-MM-01"),
      });
      setDataList(data.data.dtOffshoreList);
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  useEffect(() => {
    //fixed header table
    let tableId = "offshore-tab-table";
    let scrollY = 195;
    function fixedTableHeader() {
      let headerTable = document.querySelector(`#${tableId} thead`);
      if (window.scrollY >= scrollY) {
        headerTable.classList.add("fixed-header");

        resizeTableHeader();
      } else {
        headerTable.classList.remove("fixed-header");
      }
    }
    function resizeTableHeader() {
      setTimeout(() => {
        let headerTable = document.querySelector(`#${tableId} thead`);
        let tr = document.querySelector(`#${tableId} tbody tr`);
        let th = headerTable.querySelector(".header-style");
        for (var i = 0; i < tr.childNodes.length; i++) {
          th.childNodes[i].style.width = `${tr.childNodes[i].offsetWidth}px`;
        }
      }, 1);
    }
    window.addEventListener("scroll", fixedTableHeader);
    document
      .querySelector(`#vertical-menu-btn`)
      .addEventListener("click", resizeTableHeader);
    return () => {
      window.removeEventListener("scroll", fixedTableHeader);
      document
        .querySelector(`#vertical-menu-btn`)
        ?.removeEventListener("click", resizeTableHeader);
    };

    //fixed header table
  }, []);
  useEffect(() => {
    generateRow();
  }, [dataList]);
  useEffect(() => {
    fetchData();
  }, [props.dateSelected]);
  useEffect(() => {
    renderColumn();
    addHeaderTable();
    if (columnDataList.length > 1) {
      // generateRow();
    }
  }, [columnDataList]);
  useEffect(() => {
    let data = [];
    modelDeviceList.map(obj => {
      columnDataList.map(objColumn => {
        if (
          obj[`${objColumn.OFFSHORECOLUMN_NAME.replaceAll(".", "_")}__data`]
            .PID == ""
        ) {
          data.push({
            ...obj[
            `${objColumn.OFFSHORECOLUMN_NAME.replaceAll(".", "_")}__data`
            ],
            OFFSHORE_DATA:
              obj[objColumn.OFFSHORECOLUMN_NAME.replaceAll(".", "_")],
          });
        }
      });
    });
    if (data.length > 0) {
      // console.log('offshore')
      intialSave(data);
    }
  }, [modelDeviceList]);
  const intialSave = async data => {
    if(permission.eGLP ){
    dispatch(loadingAction.showLoading());
    try {
      let res = await post(SAVE_DT_OFFSHPRE, data);
      if (res.resultCode == 200) {
        // dispatch(messageAction.showMessage("Save success."));
        fetchData();
      } else {
        dispatch(messageAction.showMessage(res.resultDescription));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  }
  };

  const addFieldToModelDeviceList = rowList => {
    if (rowList.length > 0) {
      let data = dataList;
      // console.log(dataList);
      let modelList = [];
      columnDataList.map(objColumn => {
        modelList = rowList.map(obj => {
          let value = data.find(
            value =>
              value.OFFSHORECOLUMN_PID == objColumn.PID &&
              value.OFFSHORE_DAY == obj.OFFSHORE_DAY
          );
          // if (value == undefined) {
          //  value = data.find(
          //     value => value.OFFSHORECOLUMN_PID == objColumn.PID

          //   );
          // }
          // console.log(value);
          // let value = dataModel
          let cellValue = value ? value.OFFSHORE_DATA : 0;

          obj[objColumn.OFFSHORECOLUMN_NAME.replaceAll(".", "_")] = cellValue;
          obj[`${objColumn.OFFSHORECOLUMN_NAME.replaceAll(".", "_")}__data`] = {
            ...dataModel,
            ...value,
            OFFSHORE_DATE: obj.OFFSHORE_DATE,
            OFFSHORE_DAY: obj.OFFSHORE_DAY,
            OFFSHORECOLUMN_PID: objColumn.PID,
            OFFSHORECOLUMN_ORDER: objColumn.OFFSHORECOLUMN_ORDER,
            OFFSHORECOLUMN_NAME: objColumn.OFFSHORECOLUMN_NAME,
          };
          return { ...obj };
        });
      });
      // console.log(modelList);
      return modelList;
    }
  };
  const PickColor = (cellContent, row) => {
    return (
      <SelectColor
        value={cellContent}
        onChange={selected => {
          setColumnManageList(prev => {
            return prev.map(obj => {
              if (row.ROW == obj.ROW) {
                return {
                  ...obj,
                  color: selected,
                  OFFSHORECOLUMN_TYPE: selected.value,
                };
              }
              return { ...obj };
            });
          });
        }}
      />
    );
  };

  const SelectStyle = {
    option: (provided, { data, isDisabled, isFocused, isSelected }) => ({
      ...provided,
      ...isFocused && ({ backgroundColor: '#2E3460' })
    }),
  }

  const SelectShow = (cellContent, row) => {
    return (
      <Select
        value={cellContent}
        options={[
          { label: "Show", value: 1 },
          { label: "Hide", value: 0 },
        ]}
        classNamePrefix="select2-selection"
        styles={SelectStyle}
        onChange={selected => {
          setColumnManageList(prev => {
            return prev.map(obj => {
              if (row.ROW == obj.ROW) {
                return {
                  ...obj,
                  show: selected,
                  OFFSHORECOLUMN_SHOW: selected.value,
                };
              }
              return { ...obj };
            });
          });
        }}
      />
    );
  };
  const columnManage = [
    {
      dataField: "OFFSHORECOLUMN_ORDER",
      text: "Order",
      headerAlign: "center",
      sort: true,
      editable: true,
      align: "center",
      style: {
        width: "50px",
        cursor:"pointer",
      },
      type: "number",
    },

    {
      dataField: "OFFSHORECOLUMN_NAME",
      text: "Column Name",
      headerAlign: "center",
      sort: true,
      editable: (content, row, rowIndex, columnIndex) => row.PID == "",
      align: "center",
      style: {
        width: "100px",
      },
    },
    // {
    //   dataField: "STATUS_FLAG",
    //   text: "Source",
    //   headerAlign: "center",
    //   sort: true,
    //   editable: true,
    //   align: "center",
    //   style: {
    //     width: "150px",
    //   },
    //   editor: {
    //     type: Type.SELECT,
    //     options: [
    //       {
    //         value: 0,
    //         label: "Manual",
    //       },
    //       {
    //         value: 1,
    //         label: "SCADA",
    //       },
    //       // {
    //       //   value: 2,
    //       //   label: "Flow Selection",
    //       // },
    //       {
    //         value: 3,
    //         label: "GMDR",
    //       },
    //     ],
    //   },
    //   formatter: (cell, row, rowIndex) =>
    //     row.STATUS_FLAG == 0
    //       ? "Manual"
    //       : row.STATUS_FLAG == 1
    //       ? "SCADA"
    //       : row.STATUS_FLAG == 2
    //       ? "Flow Selection"
    //       : "GMDR",

    // },
    // {
    //   dataField: "SCADATAG_NAME",
    //   text: "SCADA Tag",
    //   headerAlign: "center",
    //   sort: true,
    //   editable: true,
    //   align: "center",
    //   style: {
    //     width: "100px",
    //   },
    // },

    // {
    //   dataField: "QTYPOINT_NAME",
    //   text: "Quality Point",
    //   headerAlign: "center",
    //   sort: true,
    //   editable: true,
    //   align: "center",
    //   style: {
    //     width: "100px",
    //   },
    // },
    // {
    //   dataField: "GMDRTAG_NAME",
    //   text: "GMDR Tag",
    //   headerAlign: "center",
    //   sort: true,
    //   editable: true,
    //   align: "center",
    //   style: {
    //     width: "100px",
    //   },
    // },
    {
      dataField: "OFFSHORECOLUMN_DESC",
      text: "Description",
      headerAlign: "center",
      sort: true,
      editable: true,
      align: "center",
      style: {
        width: "150px",
        cursor:"pointer",
      },
    },
    {
      dataField: "color",
      text: "Color",
      headerAlign: "center",
      sort: true,
      editable: false,
      align: "center",
      style: {
        width: "70px",
      },
      sortFunc: (a, b, order, dataField) => {
        if (order === "asc") {
          return b.value - a.value;
        }
        return a.value - b.value; // desc
      },
      formatter: PickColor,
    },
    {
      dataField: "show",
      text: "Status",
      headerAlign: "center",
      sort: true,
      editable: false,
      align: "center",
      style: {
        width: "100px",
      },
      sortFunc: (a, b, order, dataField) => {
        if (order === "asc") {
          return b.value - a.value;
        }
        return a.value - b.value; // desc
      },
      formatter: SelectShow,
    },
    // {
    //   dataField: "ACTION",
    //   isDummyField: true,
    //   text: "Action",
    //   headerAlign: "center",
    //   align: "center",
    //   style: {
    //     width: "150px",
    //   },
    //   formatter: deleteColumnButton,
    // },
  ];
  return (
    <div>
      <Col sm="12">
        <div className="d-flex justify-content-end">
          {permission.mMIM && (
            <button
              type="button"
              className="btn btn-primary me-2"
              onClick={() => handleShowManageColumn()}
            >
              <i className="bx bx-columns"></i>&nbsp; Manage Offshore Gas Volume
            </button>
          )}
          {/* <button
            type="button"
            className="btn btn-success me-2"
            onClick={handleSaveData}
          >
            <i className="bx bx-save"></i>&nbsp; Save
          </button> */}
        </div>
        <div className="mt-2">
          <BootstrapTable
            id="offshore-tab-table"
            keyField="OFFSHORE_DATE"
            data={modelDeviceList}
            rowStyle={rowStyle}
            columns={columnRenderList}
            headerClasses="header-style"
            cellEdit={cellEditFactory({
              mode: "click",
              blurToSave: true,
              onStartEdit: (oldValue, newValue, row, column) => {
                $("#offshore-tab-table .form-control.editor.edit-text").bind(
                  "enterKey",
                  function (e) {
                    let cell = $(this).parent().next();
                    setTimeout(() => {
                      cell.click();
                    }, 50);
                  }
                );
                $(
                  "#offshore-tab-table .form-control.editor.edit-text"
                ).keypress(function (e) {
                  if (e.keyCode == 13) {
                    $(this).trigger("enterKey");
                  }
                });
              },
              afterSaveCell: (oldValue, newValue, row, column) => {
                if (oldValue != newValue) {
                  setModelDeviceListToSave(prev => {
                    let prevData = prev.find(
                      obj => obj.OFFSHORE_DATE == row.OFFSHORE_DATE
                    );
                    if (prevData) {
                      return [
                        ...prev.map(obj => {
                          if (obj.OFFSHORE_DATE == row.OFFSHORE_DATE) {
                            return row;
                          }
                          return obj;
                        }),
                      ];
                    }
                    return [...prev, row];
                  });
                  // setTempModelDeviceList(1);
                }
                 calculateAVG();
              },
            })}
          />
            <BootstrapTable
              id="offshore-tab-avg-table"
              keyField="mode"
              data={[AVGObject]}
              columns={[
                {
                  dataField: "mode",
                  text: "",
                  headerAlign: "center",
                  editable: false,
                  align: "center",
                  headerStyle: {
                    backgroundColor: "#7E8EDA",
                    width: "50px",
                  },
                  style: { width: "50px" },
                },
                ...columnRenderList.filter((row, index) => index != 0 && index != columnRenderList.length-1),
                {
                  dataField: "show_name",
                  text: "",
                  headerAlign: "center",
                  editable: false,
                  align: "center",
                  headerStyle: {
                    backgroundColor: "#7E8EDA",
                    width: "100px",
                  },
                  style: { width: "100px" },
                },
              ]}
              rowStyle={rowStyle}
              wrapperClasses={"hidden-column mt-4"}
              headerClasses="header-style hide"
            />
        </div>
      </Col>
      <Modal size="xl" isOpen={showManageColumn} backdrop={"static"}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Manage Offshore Gas Volume</h5>

          <button
            type="button"
            onClick={() => {
              setShowManageColumn(false);
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <BootstrapTable
            id="collumn-offshore-table"
            keyField="ROW"
            data={columnManageList}
            columns={columnManage}
            rowStyle={rowStyleFontWhite}
            headerClasses="header-style"
            defaultSorted={defaultSortColumnManage}
            cellEdit={cellEditFactory({
              mode: "click",
              blurToSave: true,
              afterSaveCell: (oldValue, newValue, row, column) => {
                // console.log(columnDataList);
              },
            })}
          />
          <div className="modal-footer">
            {/* {permission.eGLP && ( */}
            {/* <> */}
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => handleAddColumn()}
            >
              <i className="bx bx-plus"></i>
              Add
            </button>

            <button
              type="button"
              className="btn btn-success"
              onClick={() => handleSaveColumn()}
            >
              <i className="bx bx-save"></i>&nbsp; Save
            </button>
            {/* </> */}
            {/* )} */}
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setShowManageColumn(false)}
            >
              Close
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
const defaultSortColumnManage = [
  {
    dataField: "OFFSHORECOLUMN_ORDER",
    order: "asc", // or desc
  },
];
export default Offshore;

const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;

//headerColumn
const deleteColumnButton = (cell, row) => (
  <OverButton
    onClick={() => {
      // onDelete(row);
    }}
    color="danger"
    icon="fas fa-trash-alt"
    label="Delete"
  />
);

Offshore.propTypes = {
  dateSelected: PropTypes.any,
};
